import { styled } from '@mui/material/styles';
import { ReactComponent as GenerateTextSVG } from 'images/generateText.svg';

export const GenerateTextIconStyled = styled(GenerateTextSVG)<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    color: disabled ? theme.palette.action.disabled : theme.palette.primary.main,
  }),
);
